import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid3X3 } from 'lucide-react';

export function SafeZoneOverlay() {
  const { t } = useTranslation();
  const [showGuides, setShowGuides] = useState(false);

  return (
    <>
      {/* Toggle button — top-right */}
      <button
        onClick={() => setShowGuides(!showGuides)}
        className={`
          absolute top-2 end-2 z-10 p-1.5 rounded-[var(--radius-chip)] transition-colors
          ${showGuides
            ? 'bg-[var(--user-page-accent)]/20 text-[var(--user-page-accent)]'
            : 'bg-[var(--user-page-card-bg)]/60 text-[var(--user-page-text)] opacity-50 hover:opacity-100'
          }
        `}
        title={t('editor.safeZones', 'Safe zones')}
      >
        <Grid3X3 size={16} />
      </button>

      {/* Overlay guides */}
      {showGuides && (
        <div className="absolute inset-0 pointer-events-none z-[5]">
          {/* Action safe (90%) */}
          <div
            className="absolute border border-dashed"
            style={{
              top: '5%',
              left: '5%',
              width: '90%',
              height: '90%',
              borderColor: 'rgba(0, 255, 255, 0.3)',
            }}
          />
          {/* Title safe (80%) */}
          <div
            className="absolute border"
            style={{
              top: '10%',
              left: '10%',
              width: '80%',
              height: '80%',
              borderColor: 'rgba(255, 255, 0, 0.25)',
            }}
          />
          {/* Center crosshair */}
          <div
            className="absolute"
            style={{
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 20,
              height: 20,
            }}
          >
            <div className="absolute top-1/2 left-0 w-full h-px bg-white/20" />
            <div className="absolute left-1/2 top-0 h-full w-px bg-white/20" />
          </div>
        </div>
      )}
    </>
  );
}
